import { Staff } from "@/models/staff";
import { Pagination } from "@/models/pagination";
import { IStaff, StaffState } from "@/types/staff";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<StaffState, IStaff> = {
  single: (state, single) => {
    state.single = new Staff(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Staff(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Staff();
    state.pagination = new Pagination();
  },
};

export default mutations;
